module.exports = __webpack_public_path__ + "3721e64a21665d2ab83c0df4b8a4cc02.svg";